<template>
  <div>
    <div class="color-schema-select">
      <div v-for="item in items" :key="item.id">
        <label class="color-schema-select-item"
          :class="{'active': computedValue.indexOf(item.id) != -1}">
          <div class="color-grid">
            <div v-for="(color, key) in item.colorScheme" 
              :key="key"
              class="color-grid-item"
              :style="'background-color:' + color">
            </div>
          </div>
          {{item.name}}
          <input
            type="checkbox"
            style="display: none;"
            :value="item.id"
            v-model="computedValue">
        </label>
      </div>
    </div>

    <div class="simple-color-select">
      <label v-for="(item, key) in simpleColors" :key="key"
        class="simple-color-select-item color-grid-item"
        :class="{'active': computedValue.indexOf(item.id) != -1}"
        :style="'background-color:' + item.color">
        <input
          type="checkbox"
          style="display: none;"
          :value="item.id"
          v-model="computedValue">
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ColorSelect',
  props: [
    'value',
  ],
  data() {
    return {
      items: [{
        id: 1,
        name: 'Simple',
        colorScheme: [
          '#f7f7f7', '#f7f7f7', '#24b4fc',
          '#f7f7f7', '#24b4fc', '#f7f7f7',
          '#24b4fc', '#f7f7f7', '#f7f7f7'
        ]
      }, {
        id: 2,
        name: 'Vibrant',
        colorScheme: [
          '#f7f7f7', '#f7f7f7', '#0019ff',
          '#f7f7f7', '#06edff', '#f7f7f7',
          '#ff03ff', '#f7f7f7', '#f7f7f7'
        ]
      }, {
        id: 3,
        name: 'Organic',
        colorScheme: [
          '#eedcc3', '#eedcc3', '#ad5532',
          '#eedcc3', '#a1a1c1', '#eedcc3',
          '#67582e', '#eedcc3', '#eedcc3'
        ]
      }, {
        id: 4,
        name: 'Black and White',
        colorScheme: [
          '#f7f7f7', '#f7f7f7', '#262626',
          '#f7f7f7', '#686868', '#f7f7f7',
          '#bcbcbc', '#f7f7f7', '#f7f7f7'
        ]
      }, {
        id: 5,
        name: 'Brutalist',
        colorScheme: [
          '#00ff00', '#00ff00', '#0000ff',
          '#00ff00', '#ff0000', '#00ff00',
          '#ffff00', '#00ff00', '#00ff00'
        ]
      }, {
        id: 6,
        name: 'Soft pastel',
        colorScheme: [
          '#9ac7fc', '#9ac7fc', '#ffff88',
          '#9ac7fc', '#ffffff', '#9ac7fc',
          '#fecaff', '#9ac7fc', '#9ac7fc'
        ]
      }],
      simpleColors: [{
        id: 7,
        color: '#ef3030'
      }, {
        id: 8,
        color: '#f9a52b'
      }, {
        id: 9,
        color: '#f7e500'
      }, {
        id: 10,
        color: '#56e20c'
      }, {
        id: 11,
        color: '#0ff7f7'
      }, {
        id: 12,
        color: '#1868e8'
      }, {
        id: 13,
        color: '#c61aff'
      }],
      newValue: this.value,
    }
  },
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.newValue = val;
        this.$emit('input', val);
      }
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/scss/variables.scss';

.color-schema-select {
  font-size: 0.7em;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  & > div {
    width: 33.3333%;
    display: flex;
    justify-content: center;
  }

  .color-schema-select-item {
    cursor: pointer;
    color: $light-grey;
    text-align: center;
    display: inline-block;
    line-height: 2;
    margin-bottom: 3.5em;
    text-transform: capitalize;

    .color-grid {
      border-radius: 6px;
      width: 5.25em;
      height: 5.25em;
      display: flex;
      flex-wrap: wrap;
      overflow: hidden;
      border: 3px solid transparent;
      box-sizing: content-box;
    }

    &.active .color-grid {
      border-color: $charcoal-grey;
      box-shadow: 1px 1px 10px 0 rgba(35, 31, 32, 0.25);
    }
  }
}

.color-grid-item {
  width: 1.75em;
  height: 1.75em;
}

.simple-color-select {
  display: flex;
  justify-content: space-between;

  .simple-color-select-item {
    border-radius: 6px;
    border: 3px solid transparent;
    cursor: pointer;

    &.active {
      border-color: $charcoal-grey;
      box-shadow: 1px 1px 10px 0 rgba(35, 31, 32, 0.25);
    }
  }
}

@media (min-width: 380px) {
  .color-schema-select {
    font-size: 1em;
  }
}

@media (min-aspect-ratio: 9/16) and (orientation: landscape) and (max-width: 768px) {
  .simple-color-select {
    flex-wrap: wrap;
    align-items: flex-start;
    width: 10em;
    max-width: 10em;
    
    .simple-color-select-item {
      margin: 0 1em 1em 0;
    }
  }

  .color-schema-select {

    .color-schema-select-item {
      margin-bottom: 1em;
      line-height: 1.2;
    }
  }
}

@media (min-width: 1200px) {

  .color-schema-select {

    .color-schema-select-item {

      .color-grid {
        width: 6.75em;
        height: 6.75em;
      }
    }
  }

  .color-grid-item {
    width: 2.25em;
    height: 2.25em;
  }
}
</style>
